import { getLocalStorage } from "./location";

export const showPopup = (key) => {
  const val = getLocalStorage().getItem(key);

  return val !== "true";
};
